import { Injectable } from '@angular/core';
import {environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EncrDecrService } from '../../services/encr-decr.service';


@Injectable({
  providedIn: 'root'
})
export class PendingEventsService {

  constructor(private http: HttpClient,
    private EncDecrService: EncrDecrService) { }

    getAllPendingEvents() {
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.post(environment.apiURI + 'admin/events/pending', {'country': ''},{headers: headers_object}).toPromise()
    }

    modifyEventStatus(id, status) {
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.post(environment.apiURI + 'admin/events/accept', {event_id:id, status:status},{headers: headers_object}).toPromise()
    }

    updateCategory(id, category) {
      const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
      var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
      return this.http.post(environment.apiURI + 'admin/events/update', {event_id:id, category:category},{headers: headers_object}).toPromise()
    }
}
